import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Container from '@mui/material/Container';
import { Button, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { resetPasswordTokenCheck, resetPassword } from "../../api/Api";
import { useNavigate } from "react-router-dom";
import GlowCard from '../../shared/GlowCard';
import { useColors } from '../../theme/ColorModeContext';
import AuthBrandHeader from '../../shared/AuthBrandHeader';

const ResetPassword = () => {
    const colors = useColors();
    const [processing, setProcessing] = useState(false);
    const [message, setMessage] = useState("");
    const { token } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const checkToken = async () => {
            const data = await resetPasswordTokenCheck(token);
            if(data == null) navigate("/login");
        }
        checkToken();
    }, []);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        const new_password = `${data.get("new_password")}`;
        const confirm_new_password = `${data.get("confirm_new_password")}`;
        setProcessing(true);
        const response = await resetPassword(token, { new_password, confirm_new_password });
        setProcessing(false);
        setMessage(response.msg);
    };

    return (
        <Container sx={{ marginTop: '120px', marginBottom: '60px' }} disableGutters maxWidth="sm" className="page-enter">
            <AuthBrandHeader />
            <GlowCard gradientBorder sx={{ padding: '48px 32px' }}>
                <Box
                    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                    component="form"
                    onSubmit={handleSubmit}
                >
                    <Typography variant="h4" sx={{
                        fontFamily: '"Orbitron", sans-serif',
                        fontWeight: 700,
                        background: colors.gradient.primary,
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        marginBottom: '32px',
                    }}>
                        Set New Password
                    </Typography>
                    <Box sx={{ width: '100%' }}>
                        <TextField margin="normal" required fullWidth id="new_password" label="New Password" name="new_password" autoFocus type="password" />
                        <TextField margin="normal" required fullWidth id="confirm_new_password" label="Confirm New Password" name="confirm_new_password" type="password" />
                        {message && (
                            <Typography variant="body2" sx={{
                                color: colors.accent.cyan,
                                marginTop: '12px',
                                padding: '8px 12px',
                                backgroundColor: colors.accent.cyanGlow,
                                borderRadius: '8px',
                                textAlign: 'center',
                            }}>
                                {message}
                            </Typography>
                        )}
                        <Button type="submit" fullWidth variant="contained" disabled={processing} sx={{ mt: 3, padding: '12px' }}>
                            Update
                        </Button>
                    </Box>
                </Box>
            </GlowCard>
        </Container>
    );
}

export default ResetPassword;
